import { Type } from "@sinclair/typebox";
import { buildingUsageSchema } from "./building-usage.js";
import { roofEvidenceSummarySchema } from "./roof-evidence.js";
const nullableText = Type.Union([Type.String(), Type.Null()]);
export const roofEvidenceResultKindSchema = Type.Union([
    Type.Literal("building"),
    Type.Literal("source_record")
]);
export const roofEvidenceCorrectionSchema = Type.Object({
    version: Type.Integer({ minimum: 0 }),
    remediationState: Type.Union([Type.Literal("complete"), Type.Null()]),
    linkedBuildingId: nullableText,
    note: Type.String(),
    updatedAt: nullableText
}, { additionalProperties: false });
export const roofEvidenceCorrectionInputSchema = Type.Object({
    expectedVersion: Type.Integer({ minimum: 0 }),
    remediationState: Type.Optional(Type.Union([Type.Literal("complete"), Type.Null()])),
    linkedBuildingId: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])),
    note: Type.Optional(Type.String({ maxLength: 2000 }))
}, { additionalProperties: false });
export const roofEvidenceSearchResultSchema = Type.Object({
    id: Type.String(),
    kind: roofEvidenceResultKindSchema,
    buildingId: nullableText,
    observationId: nullableText,
    label: Type.String(),
    municipalityName: nullableText,
    point: Type.Union([Type.Tuple([Type.Number(), Type.Number()]), Type.Null()]),
    areaM2: Type.Union([Type.Number(), Type.Null()]),
    usage: Type.Union([buildingUsageSchema, Type.Null()]),
    summary: roofEvidenceSummarySchema,
    sources: Type.Array(Type.Object({ id: Type.String(), name: Type.String(), url: Type.String() })),
    observedAt: nullableText,
    limitation: nullableText,
    missingData: Type.Array(Type.Union([Type.Literal("area"), Type.Literal("usage")])),
    correction: roofEvidenceCorrectionSchema
}, { additionalProperties: false });
export const roofEvidenceSearchPageSchema = Type.Object({
    snapshotId: nullableText,
    revision: Type.String(),
    total: Type.Integer(),
    incompleteCount: Type.Integer(),
    items: Type.Array(roofEvidenceSearchResultSchema),
    hasMore: Type.Boolean()
});
/** Complete points for the chosen bucket, independent of list pagination. */
export const roofEvidenceMapSchema = Type.Object({
    snapshotId: nullableText,
    revision: Type.String(),
    total: Type.Integer({ minimum: 0 }),
    incompleteCount: Type.Integer({ minimum: 0 }),
    missingCoordinateCount: Type.Integer({ minimum: 0 }),
    firstPage: Type.Optional(roofEvidenceSearchPageSchema),
    points: Type.Array(Type.Object({
        id: Type.String(),
        kind: roofEvidenceResultKindSchema,
        point: Type.Tuple([Type.Number(), Type.Number()])
    }, { additionalProperties: false })),
    bounds: Type.Union([
        Type.Tuple([Type.Number(), Type.Number(), Type.Number(), Type.Number()]),
        Type.Null()
    ])
}, { additionalProperties: false });
export const roofEvidenceRegionsSchema = Type.Object({
    snapshotId: nullableText,
    revision: Type.String(),
    regions: Type.Array(Type.Object({
        regionCode: Type.String(),
        name: Type.String(),
        buildingCount: Type.Integer(),
        sourceRecordCount: Type.Integer()
    }))
});
export const roofEvidenceSelectionInputSchema = Type.Object({
    items: Type.Array(Type.Object({
        kind: roofEvidenceResultKindSchema,
        id: Type.String({ format: "uuid" }),
        snapshotId: Type.Union([Type.String({ format: "uuid" }), Type.Null()])
    }, { additionalProperties: false }), { maxItems: 50 })
}, { additionalProperties: false });
export const roofEvidenceSelectionResolutionSchema = Type.Object({
    snapshotId: nullableText,
    revision: Type.String(),
    items: Type.Array(Type.Object({
        kind: roofEvidenceResultKindSchema,
        id: Type.String(),
        status: Type.Union([
            Type.Literal("ready"),
            Type.Literal("changed"),
            Type.Literal("unavailable")
        ]),
        buildingId: nullableText,
        observationId: nullableText,
        currentResult: Type.Union([roofEvidenceSearchResultSchema, Type.Null()]),
        target: Type.Optional(Type.Object({
            label: Type.String(),
            point: Type.Union([Type.Tuple([Type.Number(), Type.Number()]), Type.Null()]),
            areaM2: Type.Union([Type.Number(), Type.Null()]),
            usage: Type.Union([buildingUsageSchema, Type.Null()])
        })),
        snapshotId: nullableText
    }))
});
//# sourceMappingURL=roof-evidence-search.js.map